const env = process.env
const config = {}
Object.assign(config, env)
export default config
